import { render, staticRenderFns } from "./DoYouHaveChildren.vue?vue&type=template&id=f57a366a&scoped=true"
import script from "./DoYouHaveChildren.vue?vue&type=script&lang=js"
export * from "./DoYouHaveChildren.vue?vue&type=script&lang=js"
import style0 from "./DoYouHaveChildren.vue?vue&type=style&index=0&id=f57a366a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57a366a",
  null
  
)

export default component.exports